import axios from 'axios'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '',
  timeout: 30000,
  withCredentials: true,
  headers: { 'X-Requested-With': 'XMLHttpRequest' }
})

service.interceptors.response.use(response => {
  if (response.config.responseType === 'blob') return response
  const body = response.data
  if (body && body.success) return body
  return Promise.reject({ msg: (body && body.msg) || '请求失败', response })
}, error => {
  const response = error.response
  const publicPage = window.location.pathname === '/login' ||
    window.location.pathname.startsWith('/waybills/share/') ||
    window.location.pathname.startsWith('/embed/')
  if (response && response.status === 401 && !publicPage) {
    const redirect = `${window.location.pathname}${window.location.search}`
    window.location.replace(`/login?redirect=${encodeURIComponent(redirect)}`)
  }
  return Promise.reject({
    msg: response && response.data && response.data.msg
      ? response.data.msg
      : (error.message || '网络请求失败'),
    response
  })
})

export const isRequestSuccess = response => Boolean(response && response.success)
export default service
